import {
  // RESET_ROLE,
  RESET_ROLEIDLIST
} from '../mutation-types'


// import { getroleIdmenu } from "@/api/power";
import { getroleId } from "@/utils/auth"


const state = {
  roleIds: [],

  roleId: getroleId()

}

const mutations = {
  // [RESET_ROLE](state, buttons) {
  //   state.buttons = buttons
  // },
  [RESET_ROLEIDLIST](state, roleIds) {
    state.roleIds = roleIds
    // console.log(roleIds);

  }
}

const actions = {
  // async getInfo({ commit, state }) {

  //   const res = await getroleIdmenu(state.roleId)
  //   let menuList = []
  //   menuList = res.data
  //   let buttonAuthList = []//按钮数组
  //   menuList.forEach(button => {
  //     if (button.buttonList != "") {
  //       button.buttonList.forEach(item => {
  //         buttonAuthList.push(item.buttonId)
  //       })


  //       if (button.children != "") {
  //         button.children.forEach(items => {

  //           if (items.buttonList != "") {
  //             items.buttonList.forEach(it => {
  //               buttonAuthList.push(it.buttonId)
  //             })
  //           }
  //         })
  //       }

  //     }

  //   })

  //   commit(RESET_ROLE, buttonAuthList)
  // },

  setImgSrc({ commit }, data) {
    commit("updateImgSrc", data);
  },
  getroleIds({ commit, state }, roleIds) {

    commit(RESET_ROLEIDLIST, roleIds)
  }
}

export default {
  state,
  mutations,
  actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/role.js